<template>
  <div v-on:mouseout="$emit('hover', defaultValue)">
    <div id="timezone-picker" ref="container">
      <canvas ref="map-canvas"></canvas> 
      <img id="timezone-image" ref="map-img" :src="mapImg" :width="dimension.width" :height="dimension.height" usemap="#timezone-map" />
      <!-- <img class="timezone-pin" src="http://timezonepicker.com/images/pin.png" style="padding-top: 4px;" /> -->
      <map name="timezone-map" id="timezone-map">
        <area @click.prevent="clickHandler" 
          v-on:mouseover="mouseHandler($event, 'hover')" 
          v-on:mouseout="mouseHandler($event, 'leave')" 
          v-for="(value, timezone) in mapCords" 
          :data-timezone="timezone" 
          :data-country="value.country" 
          :data-pin="value.pin.join()" 
          :data-offset="value.offset" 
          :shape="value.polys.length > 0 ? 'poly' : 'rect'" 
          :coords="value.polys.length > 0 ? value.polys.join() : value.rects.join()" 
          :key="timezone" 
          :title="getCountryName(value.country)" />
      </map>
      
      <h3 v-show="dimension.width < 1">Sorry, map not supported for your device.</h3>
    </div>

    <div class="mt-3" v-if="showDropDown">
      <v-select @input="selectHandler" placeholder="Select Timezone" :options="timezones"></v-select>
    </div>
  </div>
  <!-- <vs-popup :title="$t('Timezone')" :active="true" fullscreen>
  </vs-popup> -->
</template>

<script>
import mapCords from '@/utils/map-coordinates/coordinates';
import highlighter from '@/utils/map-highlighter';
import vSelect from "vue-select";
import { sleep , names} from '@/utils/helper';

export default {
  props: ['modelValue', 'showDropDown', 'defaultValue'],
  emits: ['update:modelValue', 'change'],
  components: {vSelect},
  data: () => ({
    dimension: {width: 0, height: 1},
    mapCords: {}
  }),
  computed: {
    mapImg() {
      return `/timezone-maps/mapw${this.dimension.width}.png`;
    },
    timezones() {
      return Object.entries(this.mapCords)
      .map((_) => _[0]);
    }
  },
  mounted() {
    console.log('mounted >> picker');
    this.setDimension();
    this.$refs['map-img'].addEventListener('load', this.init);
    console.log(this.$refs);
  },
  watch: {
    defaultValue(v) {
      const areaEl = this.$el.querySelector('area');
      if(areaEl)
        highlighter.myLeave(areaEl);
      // console.log('areaEl', areaEl)
      this.setDefaultTz();
    },
    dimension(dimension) {
      console.log('dimention-width updated', dimension.width);
      this.mapCords = mapCords[`w${dimension.width}`];
      console.log('this.mapCords', this.mapCords);
    }
  },
  beforeDestroy() {
    this.$refs['map-img'].removeEventListener('load', this.init);
  }, 
  methods: {
    getCountryName(code){
      let countryNames = names();
      let country = countryNames.find(item => item.code === code);
      return country ? country.name : code;      
    },
    selectHandler(timezone) {
      this.$emit('timezone', timezone);
    },
    setDimension() {
      // console.log('contaner >> ',this.$refs.container.offsetWidth);
      const width = this.$refs.container.offsetWidth;
      console.log('width >> ', width);
      if(width >= 1250)
        this.dimension = {width:1250, height:625};
      else if(width >= 1080)
        this.dimension = {width:1080, height:540};
      else if(width >= 600)
        this.dimension = {width:800, height:400};
      else if(width >= 360)
        this.dimension = {width:600, height:300};
      else if(width >= 280)
        this.dimension = {width:280, height:140};
      else
        this.dimension = {width:0, height:0};
      // this.dimension.height = Math.round(this.dimension.width / 2);
    },
    async init() {
      await sleep(2);
      console.log('init called', this.dimension.width);
      if(this.dimension.width < 1)
        return;  
      highlighter.myInit(this.$refs['map-img'], this.$refs['map-canvas']);
      this.setDefaultTz();
    },
    setDefaultTz() {
      // console.log('setDefaultTz:defaultValue', this.defaultValue)
      const areaEl = this.$el.querySelector(`[data-timezone="${this.defaultValue}"]`);
      if(areaEl) {
        // console.log('setDefaultTz:areaEl', areaEl);
        highlighter.setCanvasProps({lineWidth:2});
        highlighter.myHover(areaEl);
        highlighter.setCanvasProps({lineWidth:1});
      }
    },
    clickHandler(ev) {
      this.$emit('timezone', ev.target.dataset.timezone);
    },
    mouseHandler(ev, type) {
      if(highlighter.hdc == null){
        console.log('hdc is null');
         return;
      }
      if(type == 'hover'){
        highlighter.myHover(ev.target);
        this.$emit('hover', ev.target.dataset.timezone);
      }else if(type == 'leave')
        highlighter.myLeave(ev.target);
        this.setDefaultTz();
      // console.log(ev.target);
    }
  }
}
</script>

<style scoped>
canvas
{
    pointer-events: none;       /* make the canvas transparent to the mouse - needed since canvas is position infront of image */
    position: absolute;
}
</style>